/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
/* import AddIcon from "@mui/icons-material/Add";
 import EditIcon from "@mui/icons-material/Edit";  */
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
/* import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close"; */
import {
  // GridRowsProp,
  // GridRowModesModel,
  // GridRowModes,
  DataGrid,
  // GridRowParams,
  // MuiEvent,
  // GridToolbarContainer,
  GridActionsCellItem,
  // GridEventListener,
  GridRowId,
  GridRowModel,
  GridColDef,
  // GridRenderCellParams,
  // useGridApiContext,
} from "@mui/x-data-grid";
import {
  Alert,
  AlertProps,
  // Autocomplete,
  // AutocompleteInputChangeReason,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  // TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import { LogTrackUser } from "../../../types/log-track-user/log-track-user";
import { AsyncPaginate } from "react-select-async-paginate";
import Cookies from "js-cookie";

//DATA GRID FUNCTIONS
//Autocomplete section

interface ShippingMethodStore {
  id: number;
  shipping_method_id: number;
  store_id: number;
  destination_country_id: number;
  shipping_method: string;
  store: string;
}

const useExecuteMutation = () => {
  return React.useCallback(
    (shippingMethodStore: Partial<ShippingMethodStore>) =>
      new Promise<Partial<ShippingMethodStore>>((resolve, reject) =>
        setTimeout(() => {
          if (
            shippingMethodStore.shipping_method_id === 0 ||
            shippingMethodStore.store_id === 0 ||
            shippingMethodStore.destination_country_id === 0
          ) {
            reject();
          } else {
            resolve(shippingMethodStore);
          }
        }, 200)
      ),
    []
  );
};

function computeMutation(newRow: GridRowModel, oldRow: GridRowModel) {
  if (newRow.delivery_additional_time !== oldRow.delivery_additional_time) {
    return `Shipping Method Code: '${oldRow.shipping_method_code}', Store: '${oldRow.store}', Destination Country: '${oldRow.destination_country}' Delivery Additional Time from '${oldRow.delivery_additional_time}' to '${newRow.delivery_additional_time}'`;
  }
  if (newRow.fixed_additional_cost !== oldRow.fixed_additional_cost) {
    return `Shipping Method Code: '${oldRow.shipping_method_code}', Store: '${oldRow.store}', Destination Country: '${oldRow.destination_country}' Fixed Additional Shipping Cost from '${oldRow.fixed_additional_cost}' to '${newRow.fixed_additional_cost}'`;
  }
  if (newRow.multiplier_cost !== oldRow.multiplier_cost) {
    return `Shipping Method Code: '${oldRow.shipping_method_code}', Store: '${oldRow.store}', Destination Country: '${oldRow.destination_country}' Shipping Cost Multiplier from '${oldRow.multiplier_cost}' to '${newRow.multiplier_cost}'`;
  }
  if (newRow.activation_initial_value !== oldRow.activation_initial_value) {
    return `Shipping Method Code: '${oldRow.shipping_method_code}', Store: '${oldRow.store}', Destination Country: '${oldRow.destination_country}' Minimum Total Order Value to Activate Shipping Method from '${oldRow.activation_initial_value}' to '${newRow.activation_initial_value}'`;
  }
  if (newRow.sort_order !== oldRow.sort_order) {
    return `Shipping Method Code: '${oldRow.shipping_method_code}', Store: '${oldRow.store}', Destination Country: '${oldRow.destination_country}' Sort Order from '${oldRow.sort_order}' to '${newRow.sort_order}'`;
  }
  return null;
}

export default function ListShippingMethodStores() {
  //User Tracking Logging Section //////////////////////////////////////
  let [alreadySetLog, setAlreadySetLog] = useState(false);
  const location = useLocation();
  if (!alreadySetLog) {
    LogTrackUser(Cookies.get("username"), location.pathname);
    setAlreadySetLog(true as boolean);
  }
  ///////////////////////////////////////////////////////////////////
  const [loading, setLoading] = useState(false);

  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 100,
  });
  const [rowCountState, setRowCountState] = React.useState(0);
  const [shippingMethodStores, setShippingMethodStores] = useState<
    {
      id: number;
      shipping_method_id: number;
      shipping_method: string;
      store: string;
      store_id: number;
      destination_country_id: number;
      destination_country: string;
      delivery_additional_time: number;
      delivery_time_unit: string;
      fixed_additional_cost: number;
      multiplier_cost: number;
      activation_initial_value: number;
      sort_order: number;
      created_at: Date;
      updated_at: Date;
    }[]
  >([]);
  //const [nextID, setNextID] = React.useState(0);

  //const columns = ["ID", "Parent ID", "Name", "Path", "Actions", "Delete"];
  //const keys = ["id", "parent_id", "name", "path", "action", "delete"];
  const fetchData = async (page = 1, numberItemsPerPage = 1000) => {
    await api
      .get(
        `/shipping-method-stores?page=${page}&limit=${numberItemsPerPage}&country_id=${
          country?.id
        }&shipping_method_id=${
          shippingMethodFilter?.id || ""
        }&store_id=${storeFilter}`
      )
      .then((res) => {
        setShippingMethodStores(res.data.items);
        // setRows(res.data.items);
        //setTotalPages(res.data.total_pages);
        setRowCountState(res.data.total);
      });
  };

  const defaultAdditional = {
    page: 1,
  };

  //COUNTRY
  const loadOptionsCountries = async (search: any, page: any) => {
    const results = await api.get(
      `/countries?page=${page}&limit=0&search=${search}`
    );
    const hasMore = results.data.total_pages === results.data.current_page;
    return {
      options: results.data.items,
      hasMore: !hasMore,
    };
  };

  const loadPageOptionsCountries = async (
    q: any,
    _prevOptions: any,
    { page }: any
  ) => {
    const { options, hasMore } = await loadOptionsCountries(q, page);
    return {
      options,
      hasMore,
      additional: {
        page: page + 1,
      },
    };
  };

  const [country, setCountry] = useState<{ id: number; name: string } | null>(
    null
  );

  //SHIPPING METHODS
  const loadOptionsShippingMethods = async (search: any, page: any) => {
    const results = await api.get(
      `/shipping-methods?page=${page}&limit=0&search=${search}`
    );
    const hasMore = results.data.total_pages === results.data.current_page;
    return {
      options: results.data.items,
      hasMore: !hasMore,
    };
  };

  const loadPageOptionsShippingMethods = async (
    q: any,
    _prevOptions: any,
    { page }: any
  ) => {
    const { options, hasMore } = await loadOptionsShippingMethods(q, page);
    return {
      options,
      hasMore,
      additional: {
        page: page + 1,
      },
    };
  };

  const [shippingMethodFilter, setShippingMethodFilter] = useState<{
    id: number;
    code: string;
    name: string;
  } | null>(null);

  // STORES
  const [storeFilter, setStoreFilter] = useState(0);
  const [stores, setStores] = useState<{ id: number; name: string }[]>([]);
  const fetchStores = async () => {
    const response = await api.get(`stores?page=0&limit=500`);
    setStores(response.data.items);
  };

  const handleSearchClick = () => {
    fetchData(1, 1000);
  };

  // NEW INSERT SECTION
  const [countryNew, setCountryNew] = useState<{
    id: number;
    name: string;
  } | null>(null);
  const [shippingMethodNew, setShippingMethodNew] = useState<{
    id: number;
    code: string;
    name: string;
  } | null>(null);
  const [storeNew, setStoreNew] = useState(0);

  const handleNewClick = async () => {
    if (countryNew && shippingMethodNew && storeNew > 0) {
      let shippingMethodStore = {} as any;
      shippingMethodStore.shipping_method_id = shippingMethodNew?.id;
      shippingMethodStore.store_id = storeNew;
      shippingMethodStore.destination_country_id = countryNew?.id;

      api
        .post(`shipping-method-stores`, shippingMethodStore)
        .then((response) => {
          Swal.fire({
            title: "Shipping Method Store Created!",
            icon: "success",
            confirmButtonText: "Yes",
          });
          fetchData(1, 1000);
        })
        .catch((error) => {
          Swal.fire({
            title: "Ops...",
            icon: "error",
            text: error.response.data.message,
            confirmButtonText: "Yes",
          });
        });
    } else {
      Swal.fire({
        title: "Ops...",
        icon: "error",
        text: "Shipping Method, Store and Country must be defined!",
        confirmButtonText: "Yes",
      });
    }
  };

  //DATAGRID SECTION
  //Edit Section
  /* const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>(
    {}
  ); */

  const handleDeleteClick = (id: GridRowId) => () => {
    //Message to Confirm DELETION
    Swal.fire({
      title: `Are you sure to delete the ID ${id}?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        //Call API to delete de database
        api
          .delete(`shipping-method-stores/${id}`)
          .then((res) => {
            Swal.fire("Deleted!", "It has been deleted.", "success");
            fetchData(1, 1000);
          })
          .catch((error) => {
            console.error(error);
          });
      }
    });
  };

  const mutateRow = useExecuteMutation();
  const noButtonRef = React.useRef<HTMLButtonElement>(null);
  const [promiseArguments, setPromiseArguments] = React.useState<any>(null);

  const [snackbar, setSnackbar] = React.useState<Pick<
    AlertProps,
    "children" | "severity"
  > | null>(null);

  const handleCloseSnackbar = () => setSnackbar(null);

  const processRowUpdate = React.useCallback(
    (newRow: GridRowModel, oldRow: GridRowModel) =>
      new Promise<GridRowModel>((resolve, reject) => {
        const updatedRow = { ...newRow, isNew: false };
        const mutation = computeMutation(newRow, oldRow);
        if (mutation) {
          // Save the arguments to resolve or reject the promise later
          setPromiseArguments({ resolve, reject, newRow, oldRow });
        } else {
          resolve(oldRow); // Nothing was changed
        }
        //setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
        return updatedRow;
      }),
    []
  );

  const handleNo = () => {
    const { oldRow, resolve } = promiseArguments;
    resolve(oldRow); // Resolve with the old row to not update the internal state
    setPromiseArguments(null);
  };

  const handleYes = async () => {
    const { newRow, oldRow, reject, resolve } = promiseArguments;

    try {
      // Make the HTTP request to save in the backend
      let shippingMethodStoreUpdate = {} as any;
      shippingMethodStoreUpdate.shipping_method_id = newRow.shipping_method_id;
      shippingMethodStoreUpdate.store_id = newRow.store_id;
      shippingMethodStoreUpdate.destination_country_id =
        newRow.destination_country_id;
      shippingMethodStoreUpdate.delivery_additional_time = Number(
        newRow.delivery_additional_time
      );
      shippingMethodStoreUpdate.fixed_additional_cost = Number(
        newRow.fixed_additional_cost
      );
      shippingMethodStoreUpdate.multiplier_cost = Number(
        newRow.multiplier_cost
      );
      shippingMethodStoreUpdate.activation_initial_value = Number(
        newRow.activation_initial_value
      );
      shippingMethodStoreUpdate.sort_order = Number(newRow.sort_order);

      await api.put(
        `shipping-method-stores/${newRow.id}`,
        shippingMethodStoreUpdate
      );

      const response = await mutateRow(newRow);
      setSnackbar({
        children: "Shipping Method Store successfully saved",
        severity: "success",
      });
      resolve(response);
      setPromiseArguments(null);
    } catch (error) {
      console.error(error);
      setSnackbar({ children: "Error! Invalid Data!", severity: "error" });
      reject(oldRow);
      setPromiseArguments(null);
    }
  };

  const handleEntered = () => {
    // The `autoFocus` is not used because, if used, the same Enter that saves
    // the cell triggers "No". Instead, we manually focus the "No" button once
    // the dialog is fully open.
    // noButtonRef.current?.focus();
  };

  const renderConfirmDialog = () => {
    if (!promiseArguments) {
      return null;
    }

    const { newRow, oldRow } = promiseArguments;
    const mutation = computeMutation(newRow, oldRow);

    return (
      <Dialog
        maxWidth="xs"
        TransitionProps={{ onEntered: handleEntered }}
        open={!!promiseArguments}
      >
        <DialogTitle>Are you sure?</DialogTitle>
        <DialogContent dividers>
          {`Pressing 'Yes' will ${mutation}.`}
        </DialogContent>
        <DialogActions>
          <Button ref={noButtonRef} onClick={handleNo}>
            No
          </Button>
          <Button onClick={handleYes}>Yes</Button>
        </DialogActions>
      </Dialog>
    );
  };

  const currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const columns: GridColDef[] = [
    {
      field: "id",
      headerName: "ID",
      editable: false,
      width: 70,
    },
    {
      field: "shipping_method_code",
      headerName: "CODE",
      width: 150,
      editable: false,
    },
    {
      field: "shipping_method",
      headerName: "Shipping Method",
      width: 250,
      editable: false,
    },

    {
      field: "store",
      headerName: "Store",
      width: 150,
      editable: false,
    },
    {
      field: "destination_country",
      headerName: "Available Country",
      width: 150,
      editable: false,
    },
    {
      field: "delivery_additional_time",
      headerName: "Delivery Add. Time",
      type: "number",
      width: 150,
      editable: true,
    },

    {
      field: "delivery_time_unit",
      headerName: "Unit",
      type: "string",
      width: 100,
      editable: false,
    },
    {
      field: "fixed_additional_cost",
      headerName: "Fixed Add. Cost",
      type: "number",
      width: 150,
      editable: true,
      valueFormatter: (value) =>
        value === null ? "" : currencyFormatter.format(value),
    },

    {
      field: "multiplier_cost",
      headerName: "Cost Multiplier",
      type: "number",
      width: 150,
      editable: true,
    },
    {
      field: "activation_initial_value",
      headerName: "Min. Order Total Act.",
      type: "number",
      width: 150,
      editable: true,
      valueFormatter: (value) =>
        value === null ? "" : currencyFormatter.format(value),
    },
    {
      field: "sort_order",
      headerName: "Sort Order",
      type: "number",
      width: 100,
      editable: true,
    },

    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  //LOAD INITIAL VALUES
  useEffect(() => {
    fetchData();
    fetchStores();
  }, []);

  useEffect(() => {
    let active = true;

    (async () => {
      setLoading(true);
      fetchData(paginationModel.page + 1, paginationModel.pageSize);

      if (!active) {
        return;
      }

      setLoading(false);
    })();

    return () => {
      active = false;
    };
  }, [paginationModel.page]);

  return (
    <Container maxWidth="xl" sx={{ width: "100%", mt: 2, mb: 4 }}>
      <Typography
        component="h1"
        variant="h5"
        sx={{
          paddingTop: "40px",
          fontWeight: "bold",
          fontSize: "32px",
          color: "#556cd6",
          paddingLeft: "20px",
        }}
      >
        Shipping Methods & Store
      </Typography>
      <Box style={{ display: "flex", flexDirection: "row" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            marginRight: "8px",
            marginLeft: 1,
            width: "25%",
          }}
        >
          <InputLabel id="store-filter-label">Store Filter:</InputLabel>
          <Select
            labelId="store-select-label"
            id="store"
            value={String(storeFilter)}
            label="Store"
            onChange={(e) => setStoreFilter(Number(e.target.value))}
          >
            <MenuItem value={0}>None</MenuItem>
            {stores.map((store, index) => (
              <MenuItem value={store.id} key={index}>
                {store.name}
              </MenuItem>
            ))}
          </Select>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            marginRight: "8px",
            marginLeft: 1,
            width: "25%",
          }}
        >
          <InputLabel id="country-filter-label">Country Filter:</InputLabel>
          <AsyncPaginate
            placeholder="Select Country"
            styles={{
              menu: (provided) => ({
                ...provided,
                zIndex: 9999,
              }),
            }}
            additional={defaultAdditional}
            key={"country_id"}
            id="country"
            name="country"
            getOptionValue={(option: any) => option?.id}
            getOptionLabel={(option: any) => option?.name}
            loadOptions={loadPageOptionsCountries}
            value={country}
            onChange={setCountry}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            marginRight: "8px",
            marginLeft: 1,
            width: "25%",
          }}
        >
          <InputLabel id="shipping-method-filter-label">
            Shipping Method Filter:
          </InputLabel>
          <AsyncPaginate
            placeholder="Select Shipping Method"
            styles={{
              menu: (provided) => ({
                ...provided,
                zIndex: 9999,
              }),
            }}
            additional={defaultAdditional}
            key={"shipping_method_id"}
            id="shippingMethod"
            name="shippingMethod"
            getOptionValue={(option: any) => option?.id}
            getOptionLabel={(option: any) => option?.name}
            loadOptions={loadPageOptionsShippingMethods}
            value={shippingMethodFilter}
            onChange={setShippingMethodFilter}
          />
        </Box>

        <Button
          variant="contained"
          sx={{ m: 3 }}
          href=""
          onClick={handleSearchClick}
        >
          Filter
        </Button>
      </Box>
      To insert a new Entry, please fill the fields below and press the Insert
      Button
      <Box style={{ display: "flex", flexDirection: "row" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            marginRight: "8px",
            marginLeft: 1,
            minWidth: 1 / 4,
          }}
        >
          <InputLabel id="store-select-label">Store</InputLabel>
          <Select
            labelId="store-select-label"
            id="store"
            value={String(storeNew)}
            label="Store"
            onChange={(e) => setStoreNew(Number(e.target.value))}
          >
            <MenuItem value={0}>None</MenuItem>
            {stores.map((store, index) => (
              <MenuItem value={store.id} key={index}>
                {store.name}
              </MenuItem>
            ))}
          </Select>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            marginRight: "8px",
            marginLeft: 1,
            minWidth: 1 / 4,
          }}
        >
          <InputLabel id="productstore-store-label">Country:</InputLabel>
          <AsyncPaginate
            placeholder="Select Country"
            styles={{
              menu: (provided) => ({
                ...provided,
                zIndex: 9999,
              }),
            }}
            additional={defaultAdditional}
            key={"country_id_new"}
            id="countryNew"
            name="countryNew"
            getOptionValue={(option: any) => option?.id}
            getOptionLabel={(option: any) => option?.name}
            loadOptions={loadPageOptionsCountries}
            value={countryNew}
            onChange={setCountryNew}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            marginLeft: 1,
            marginRight: "8px",
            minWidth: 1 / 4,
          }}
        >
          <InputLabel id="productstore-store-label">
            Shipping Method:
          </InputLabel>
          <AsyncPaginate
            placeholder="Select Shipping Method"
            styles={{
              menu: (provided) => ({
                ...provided,
                zIndex: 9999,
              }),
            }}
            additional={defaultAdditional}
            key={"shipping_method_id_new"}
            id="shippingMethodNew"
            name="shippingMethodNew"
            getOptionValue={(option: any) => option?.id}
            getOptionLabel={(option: any) => option?.name}
            loadOptions={loadPageOptionsShippingMethods}
            value={shippingMethodNew}
            onChange={setShippingMethodNew}
          />
        </Box>
        <Button
          variant="contained"
          sx={{ m: 3 }}
          href=""
          onClick={handleNewClick}
        >
          New Entry
        </Button>
      </Box>
      Only Delivery Additional Time, Fixed Additional Cost, Cost Multiplier and
      Minimum Order Total are changeable. To change any of it, DOUBLE CLICK on
      the row field.
      <Box
        sx={{
          marginLeft: "8px",
          mt: "8px",
          height: 600,
          width: "100%",
          "& .actions": {
            color: "text.secondary",
          },
          "& .textPrimary": {
            color: "text.primary",
          },
        }}
      >
        {renderConfirmDialog()}
        <DataGrid
          rows={shippingMethodStores}
          columns={columns}
          processRowUpdate={processRowUpdate}
          initialState={{
            pagination: {
              paginationModel,
            },
          }}
          pagination
          paginationModel={paginationModel}
          pageSizeOptions={[25, 50, 100]}
          rowCount={rowCountState}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
          loading={loading}
        />
        {!!snackbar && (
          <Snackbar open onClose={handleCloseSnackbar} autoHideDuration={6000}>
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )}
      </Box>
    </Container>
  );
}
